import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './index.css'
import { App } from './App'
import { LoginPage } from './pages/Login'
import { NodesPage } from './pages/Nodes'
import { NodeDetailPage } from './pages/NodeDetail'
import { ClientsPage } from './pages/Clients'
import { SitesPage } from './pages/Sites'
import { DatabasesPage } from './pages/Databases'
import { DBUsersPage } from './pages/DBUsers'
import { FTPPage } from './pages/FTP'
import { CronPage } from './pages/Cron'
import { CertificatesPage } from './pages/Certificates'
import { APIKeysPage } from './pages/APIKeys'
import { FilesPage } from './pages/Files'
import { AccountPage } from './pages/Account'
import { SettingsPage } from './pages/Settings'
import { DashboardPage } from './pages/Dashboard'
import { TerminalPage } from './pages/Terminal'
import { IPAddressesPage } from './pages/IPAddresses'
import { FirewallPage } from './pages/Firewall'
import { TasksPage } from './pages/Tasks'
import { AuthProvider, RequireAuth } from './lib/auth'

const qc = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 2000 } },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<RequireAuth><App /></RequireAuth>}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/nodes" element={<NodesPage />} />
              <Route path="/nodes/:id" element={<NodeDetailPage />} />
              <Route path="/nodes/:id/terminal" element={<TerminalPage />} />
              <Route path="/ip-addresses" element={<IPAddressesPage />} />
              <Route path="/firewall" element={<FirewallPage />} />
              <Route path="/tasks" element={<TasksPage />} />
              <Route path="/clients" element={<ClientsPage />} />
              <Route path="/sites" element={<SitesPage />} />
              <Route path="/databases" element={<DatabasesPage />} />
              <Route path="/db-users" element={<DBUsersPage />} />
              <Route path="/ftp" element={<FTPPage />} />
              <Route path="/cron" element={<CronPage />} />
              <Route path="/certificates" element={<CertificatesPage />} />
              <Route path="/api-keys" element={<APIKeysPage />} />
              <Route path="/files" element={<FilesPage />} />
              <Route path="/account" element={<AccountPage />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
